module.exports = __webpack_public_path__ + "img/9788952214898.9192fa3a.jpg";